import { get } from '@/utils/request'
import useSWR from 'swr'
import { playerType, turnType } from '@/utils/types'
import { commonSWROptions } from './useAdmin'

const fetchPlayers = (match_id: string, turn: turnType) =>
  get('users/players', { match_id, turn }).then((res) => {
    if (res.ok) {
      return res.players ?? []
    }
    return []
  })

const fetchRelatedPlayers = (match_id: string) =>
  get('users/players/related', { match_id }).then((res) => {
    if (res.ok) {
      return res.players
    }
    return []
  })

export const fetchPlayer = (player_id: string) =>
  get(`users/players/${player_id}`).then((res) => {
    if (res.ok) {
      return { ...res, rounds: res.rounds ?? [], player: res.player ?? {} }
    }
    return { ...res, rounds: [], player: {} }
  })

export const usePlayers = (match_id, turn: turnType = 'sum') => {
  return useSWR(match_id ? `players-${match_id}-${turn}` : undefined, () => fetchPlayers(match_id, turn), {
    ...commonSWROptions,
    fallbackData: [],
  }) as {
    data: playerType[]
    mutate: any
    isValidating: boolean
  }
}

export const useRelatedPlayers = (match_id) => {
  return useSWR(match_id ? `related-players-${match_id}` : undefined, () => fetchRelatedPlayers(match_id), {
    ...commonSWROptions,
    fallbackData: [],
  }) as {
    data: playerType[]
    mutate: any
    isValidating: boolean
  }
}

export const usePlayer = (player_id) => {
  return useSWR(player_id ? `player-${player_id}` : undefined, () => fetchPlayer(player_id), {
    ...commonSWROptions,
    fallbackData: { rounds: [], player: {} },
  }) as {
    data: { rounds: any; player: playerType }
    mutate: any
  }
}
